import {
  Component, HostBinding, OnInit,
  ViewChild, ViewContainerRef,
  AfterViewInit, Injector, OnDestroy, ChangeDetectorRef, EventEmitter
} from '@angular/core';
import {Subscription} from 'rxjs';
import {ExgModalService} from '../exg-modal.service';
import {ExgWidgetService} from '../../exg-widget.service';

@Component({
  selector: 'exg-modal',
  templateUrl: './exg-modal.component.html',
  styleUrls: ['./exg-modal.component.scss']
})
export class ExgModalComponent implements OnInit, AfterViewInit, OnDestroy {

  @HostBinding('class.is-open')

  private isOpen = false;
  private componentRef: any = null;

  private scChange: Subscription | undefined;
  private scUpdate: Subscription | undefined;
  private scInitialize: Subscription | undefined;

  @ViewChild('vc', {read: ViewContainerRef}) entry!: ViewContainerRef;

  constructor(private popUpService: ExgModalService, private injector: Injector, private app: ExgWidgetService) {
  }

  loadComponent(name: string): void {
    this.entry.clear();
    this.componentRef = this.entry.createComponent(this.app.GetFactory(name), undefined, this.injector);
  }

  ngOnInit(): void {
    this.scChange = this.popUpService.change.subscribe((isOpen: boolean) => {
      this.isOpen = isOpen;
      if (!this.isOpen && this.componentRef) {
        this.componentRef.destroy();
        this.componentRef = null;
      }

      if (this.popUpService.forceToggleEvent) {
        this.popUpService.toggled.emit();
        this.popUpService.forceToggleEvent = false;
      }
    });
    this.scInitialize = this.popUpService.initialize.subscribe((name: string) => {
      this.loadComponent(name);
    });
    this.scUpdate = this.popUpService.update.subscribe((data: string) => {
      if (this.componentRef) {
        this.componentRef.instance.data = data;
      }
    });
  }

  ngAfterViewInit(): void {
  }

  ngOnDestroy(): void {
    if (this.scUpdate instanceof Subscription) {
      this.scUpdate.unsubscribe();
    }
    if (this.scChange instanceof Subscription) {
      this.scChange.unsubscribe();
    }
    if (this.scInitialize instanceof Subscription) {
      this.scInitialize.unsubscribe();
    }
  }


}
